import type { ComponentProps } from "react";

import { Card, Label } from "@/shared/ui";

const Title = Card.Title;
const Content = Card.Content;

const Root = ({ ...props }: ComponentProps<typeof Card.Root>) => (
  <Card.Root className="z-0" color="secondary" {...props} />
);

const Header = ({ ...props }: ComponentProps<typeof Card.Header>) => (
  <Card.Header className="min-h-10 justify-between" {...props} />
);

const Item = ({ ...props }: ComponentProps<"div">) => (
  <div
    className="flex flex-col gap-1 rounded-lg bg-white px-4 py-5"
    {...props}
  />
);

const ItemLabel = ({ size = "md", ...props }: ComponentProps<typeof Label>) => (
  <Label size={size} className="flex items-center gap-1" {...props} />
);

const ItemValue = ({ ...props }: ComponentProps<"p">) => (
  <p className="truncate pl-5 text-sm" {...props} />
);

export { Root, Header, Title, Content, Item, ItemLabel, ItemValue };
